<!--
 * @Author: DY
 * @Date: 2020-08-21 17:55:37
 * @LastEditors: name
 * @LastEditTime: 2020-08-21 19:09:50
 * @Describe:
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="seeTestBlock">
            <van-nav-bar
                title="查看试块"
                left-text="生产配比"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li v-for="(item,index) in listData" :key="index">
                                <van-cell
                                    style="font-size:16px;"
                                    :value="item.testblock_number"
                                    title="试块试验编号"
                                    :icon="require('@/assets/images/icons/icon_gy_1.png')"
                                ></van-cell>
                                <van-cell
                                    :value="item.place_name"
                                    title="施工部位"
                                    :icon="require('@/assets/images/icons/icon_gy_2.png')"
                                ></van-cell>
                                <van-cell
                                    :value="item.strength_grade_name"
                                    title="强度等级"
                                    :icon="require('@/assets/images/icons/icon_gy_3.png')"
                                ></van-cell>
                                <van-cell
                                    :value="item.measured"
                                    title="实测值"
                                    :icon="require('@/assets/images/icons/icon_16.png')"
                                ></van-cell>
                                <van-cell
                                    :value="item.instar"
                                    title="龄期"
                                    :icon="require('@/assets/images/icons/icon_gy_10.png')"
                                ></van-cell>
                                <van-cell
                                    :value="item.block_model"
                                    title="试块规格(mm)"
                                    :icon="require('@/assets/images/icons/icon_16.png')"
                                ></van-cell>
                                <van-cell
                                    :value="item.entrustingparty"
                                    title="委托单位"
                                    :icon="require('@/assets/images/icons/icon_29.png')"
                                ></van-cell>
                                <van-cell
                                    :value="item.maker"
                                    title="制作人"
                                    :icon="require('@/assets/images/icons/icon_3.png')"
                                ></van-cell>
                                <van-cell
                                    :value="item.make_time"
                                    title="制作时间"
                                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                                ></van-cell>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 查看试块
    name: 'see-test-block',
    components: {},
    props: {},
    data() {
        return {
            // 任务单号
            task_number: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否加载完数据
            finished: false,
            // 上拉索引
            count: 0,
            // 列表数据
            listData: [],
            // 列表总条数
            total: 0,
        };
    },
    created() {
        // 任务单号
        this.task_number = this.$route.params.task_number;
    },
    mounted() {},
    activated() {},
    update() {},
    beforeRouteUpdate() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 下拉刷新
        onRefresh() {
            this.count = 1;
            this.listData = [];
            this.finished = false;
            this.getInit();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.getInit();
        },
        // 获取试块列表数据
        getInit() {
            this.$axios
                .get('/interfaceApi/production/formulablockpressure/query_block_pressure?task_number='
                    + `${this.task_number}&pageindex=${this.count}&pagesize=3`)
                .then(res => {
                    this.total = res.total;
                    if (this.listData.length < 1) {
                        this.listData = res.rows;
                        this.finished = false;
                    } else {
                        this.listData.push(...res.rows);
                    }
                    if (this.listData.length === this.total) {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
    filter: {},
    computed: {},
    watch: {},
};
</script>

<style lang="stylus" scoped>
.seeTestBlock
    height 100%
    section
        height calc(100% - 45rpx)
        background #F0F0F0
        .van-pull-refresh
            height 100%
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                padding 15rpx
                li
                    margin-bottom 15rpx
                    &:last-child
                        margin-bottom 0
</style>
